































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { Public } from '@/http/api_Public'; 
import $ from 'jquery';
@Component({ 
    components: {}, 
})
export default class jintro1 extends Vue {
  
    public $refs!: {
        
    };

    async mounted() {
      
    }
    async created() {
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/home/components/jintro1.vue